import { render, staticRenderFns } from "./payMethod.vue?vue&type=template&id=4e4a5758&scoped=true"
import script from "./payMethod.vue?vue&type=script&lang=js"
export * from "./payMethod.vue?vue&type=script&lang=js"
import style0 from "./payMethod.vue?vue&type=style&index=0&id=4e4a5758&prod&lang=less&scoped=true"
import style1 from "./payMethod.vue?vue&type=style&index=1&id=4e4a5758&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4a5758",
  null
  
)

export default component.exports